import * as uuid from 'uuid';
import { ILeadCountryScore } from "services/CrmApi/types/CrmLeadTypes";

export const createEmptyScoreLine = (): ILeadCountryScore => ({
  id: uuid.v4(),
  countryCode: '',
  annualValueBookings: null,
  annualNumberBookings: null,
});
